import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const MobileNavigationLink = ({
  href,
  linkText,
  onClick,
  selected,
  target,
  item = {},
  openSubMenu,
}) => {
  const [isSubNavigation, setIsSubNavigation] = useState(
    item?.subNavigations && item?.subNavigations.length > 0,
  );
  const [isSubSubNavigation, setIsSubSubNavigation] = useState(
    item?.subSubNavigations && item?.subSubNavigations.length > 0,
  );
  const theme = useContext(ThemeContext);
  useEffect(() => {
    setIsSubNavigation(item?.subNavigations && item?.subNavigations.length > 0);
    setIsSubSubNavigation(
      item?.subSubNavigations && item?.subSubNavigations.length > 0,
    );
  }, [item]);

  const handleOnClick = (event) => {
    if (isSubSubNavigation) {
      event.preventDefault();
      openSubMenu(item.subSubNavigations);
    } else if (isSubNavigation) {
      event.preventDefault();
      openSubMenu(item.subNavigations);
    } else {
      onClick();
    }
  };

  return (
    <>
      <li
        className={`navigation-item ${
          selected ? 'navigation-item--selected' : ''
        } ${
          isSubNavigation || isSubSubNavigation ? 'with-sub-navigations' : ''
        }`}
      >
        <Link href={href ?? ''}>
          <a
            className="navigation-link"
            onClick={handleOnClick}
            onKeyDown={handleOnClick}
            role="link"
            tabIndex={0}
            target={target}
          >
            {linkText}
          </a>
        </Link>
        {(isSubNavigation || isSubSubNavigation) && (
          <div className="arrow-subnavigation">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        )}
      </li>
      <style jsx>{`
        .navigation-item {
          list-style: none;
        }
        .navigation-item--selected .navigation-link {
          color: ${theme.colors.textonprimary};
        }
        .navigation-item--selected .navigation-link-with-subnavigation {
          color: ${theme.colors.textonprimary};
        }
        .navigation-item--selected {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
        }
        .with-sub-navigations {
          display: flex;
        }
        .navigation-link {
          display: block;
          height: 100%;
          width: 90%;
          color: ${theme.colors.navlink};
          padding: 5px 12px 5px 42px;
          text-transform: ${theme.text.navigation.transform};
          text-decoration: none;
          font-size: ${theme.text.navigation.size}px;
          white-space: normal;
        }
        .arrow-subnavigation {
          width: 16px;
          height: 16px;
          margin-top: 1%;
          vertical-align: middle;
        }
        .arrow-container {
          display: inline-block;
        }
        .navigation-link-with-subnavigation {
          display: block;
          height: 100%;
          width: 90%;
          color: ${theme.colors.navlink};
          padding: 5px 12px 5px 42px;
          text-transform: ${theme.text.navigation.transform};
          text-decoration: none;
          font-size: ${theme.text.navigation.size}px;
          white-space: normal;
        }
        .navigation-link:focus {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
        }
        .navigation-link-with-subnavigation:focus {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
        }
      `}</style>
    </>
  );
};

MobileNavigationLink.propTypes = {
  href: PropTypes.string,
  item: PropTypes.object,
  linkText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  openSubMenu: PropTypes.func,
  selected: PropTypes.bool,
  target: PropTypes.string,
};

export default MobileNavigationLink;
